export function GutterDoodles() {
  return (
    <div className="gutter-doodles" aria-hidden="true">
      <div className="gutter-doodles__left">
        <svg width="180" height="700" viewBox="0 0 180 700" fill="none">
          <defs>
            <clipPath id="gdl-1">
              <rect x="22" y="8" width="110" height="68" />
            </clipPath>
            <clipPath id="gdl-2">
              <rect x="0" y="148" width="170" height="60" />
            </clipPath>
            <clipPath id="gdl-3">
              <rect x="55" y="360" width="125" height="100" />
            </clipPath>
            <clipPath id="gdl-4">
              <rect x="5" y="488" width="100" height="75" />
            </clipPath>
            <clipPath id="gdl-5">
              <rect x="15" y="620" width="165" height="80" />
            </clipPath>
          </defs>

          {/* dot grid — small, top-left */}
          <g clipPath="url(#gdl-1)" fill="currentColor">
            {[36, 68, 100, 128].map((x) => (
              <circle key={`l1a-${x}`} cx={x} cy={24} r="3" />
            ))}
            {[52, 84, 116].map((x) => (
              <circle key={`l1b-${x}`} cx={x} cy={50} r="3" />
            ))}
            {[36, 68, 100, 128].map((x) => (
              <circle key={`l1c-${x}`} cx={x} cy={72} r="3" />
            ))}
          </g>

          {/* diagonal bars — wide, close below dots */}
          <g clipPath="url(#gdl-2)" fill="currentColor">
            <g transform="rotate(-13, 85, 178)">
              <rect x="-50" y="151" width="280" height="12" />
              <rect x="-50" y="169" width="280" height="8" />
              <rect x="-50" y="183" width="280" height="11" />
              <rect x="-50" y="198" width="280" height="7" />
            </g>
          </g>

          {/* wave arcs — big gap, right-leaning, anchored bottom-right */}
          <g clipPath="url(#gdl-3)" stroke="currentColor" strokeWidth="1.5">
            <circle cx="180" cy="460" r="65" />
            <circle cx="180" cy="460" r="102" />
            <circle cx="180" cy="460" r="143" />
            <circle cx="180" cy="460" r="185" />
          </g>

          {/* diagonal lines — small, left edge, close to waves */}
          <g clipPath="url(#gdl-4)" stroke="currentColor" strokeWidth="1">
            <path d="M-30,563 L45,488 M-8,563 L67,488 M14,563 L89,488 M36,563 L111,488 M58,563 L133,488 M80,563 L155,488" />
          </g>

          {/* concentric diamonds — wide, anchored right edge, bottom */}
          <g clipPath="url(#gdl-5)" stroke="currentColor" strokeWidth="1.5">
            <polygon points="180,620 132,660 180,700 228,660" />
            <polygon points="180,594 106,660 180,726 254,660" />
            <polygon points="180,568  80,660 180,752 280,660" />
          </g>
        </svg>
      </div>

      <div className="gutter-doodles__right">
        <svg width="180" height="700" viewBox="0 0 180 700" fill="none">
          <defs>
            <clipPath id="gdr-1">
              <rect x="22" y="42" width="158" height="110" />
            </clipPath>
            <clipPath id="gdr-2">
              <rect x="0" y="255" width="130" height="85" />
            </clipPath>
            <clipPath id="gdr-3">
              <rect x="40" y="355" width="140" height="70" />
            </clipPath>
            <clipPath id="gdr-4">
              <rect x="18" y="500" width="162" height="65" />
            </clipPath>
            <clipPath id="gdr-5">
              <rect x="0" y="612" width="145" height="88" />
            </clipPath>
          </defs>

          {/* overlapping filled circles — large, top-right */}
          <g clipPath="url(#gdr-1)" fill="currentColor">
            <circle cx="168" cy="38" r="72" />
            <circle cx="48" cy="158" r="56" />
            <circle cx="122" cy="96" r="26" />
          </g>

          {/* wave arcs — big gap from top, anchored bottom-left */}
          <g clipPath="url(#gdr-2)" stroke="currentColor" strokeWidth="1.5">
            <circle cx="0" cy="340" r="58" />
            <circle cx="0" cy="340" r="95" />
            <circle cx="0" cy="340" r="136" />
            <circle cx="0" cy="340" r="177" />
          </g>

          {/* dot grid — tight cluster just below waves */}
          <g clipPath="url(#gdr-3)" fill="currentColor">
            {[54, 86, 118, 150, 178].map((x) => (
              <circle key={`r3a-${x}`} cx={x} cy={372} r="3" />
            ))}
            {[70, 102, 134, 166].map((x) => (
              <circle key={`r3b-${x}`} cx={x} cy={398} r="3" />
            ))}
            {[54, 86, 118, 150, 178].map((x) => (
              <circle key={`r3c-${x}`} cx={x} cy={420} r="3" />
            ))}
          </g>

          {/* diagonal lines — wide, medium gap */}
          <g clipPath="url(#gdr-4)" stroke="currentColor" strokeWidth="1">
            <path d="M-20,565 L45,500 M2,565 L67,500 M24,565 L89,500 M46,565 L111,500 M68,565 L133,500 M90,565 L155,500 M112,565 L177,500 M134,565 L199,500 M156,565 L221,500 M178,565 L243,500" />
          </g>

          {/* diagonal bars — left edge, close below lines */}
          <g clipPath="url(#gdr-5)" fill="currentColor">
            <g transform="rotate(-13, 72, 656)">
              <rect x="-50" y="615" width="248" height="14" />
              <rect x="-50" y="635" width="248" height="9" />
              <rect x="-50" y="650" width="248" height="12" />
              <rect x="-50" y="668" width="248" height="8" />
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
}
